export function explainDecision({
  context,
  risk,
  prediction,
  decision,
}) {
  const reasons = [];

  const safeRisk = risk || { level: "SAFE" };
  const safeContext = context || {};

  // ?? ENVIRONMENT
  if (safeContext.fentanyl > 6.5) {
    reasons.push("fentanylAboveThreshold");
  }

  if (safeContext.voc > 150) {
    reasons.push("elevatedVoc");
  }

  if (safeContext.pm25 > 50) {
    reasons.push("elevatedPm25");
    console.log("PM2.5:", safeContext.pm25);
  }

  // ?? PREDICTION
  if (prediction?.escalationProbability > 0.7) {
    reasons.push("highEscalationProbability");
  }

  // ?? FALLBACK
  if (reasons.length === 0 && safeRisk.level !== "SAFE") {
    reasons.push("riskElevatedCombinedSignals");
  }

  // ?? SMART SUMMARY
  let summary = "monitor";

  if (safeRisk.level === "CRITICAL") {
    summary = "criticalIntervention";
  } else if (safeRisk.level === "WARNING") {
    summary = "elevatedMonitoring";
  }

  return {
    summary,
    reasons,
    confidence:
      safeRisk.level === "CRITICAL" ? 95 :
      safeRisk.level === "WARNING" ? 70 :
      safeRisk.level === "SAFE" ? 40 : 50,
  };
}